import { jsx as _jsx } from "react/jsx-runtime";
// Button / IconButton — токенизированные базовые кнопки. Презентационные: только UI + onClick.
import { forwardRef } from 'react';
import { Icon } from './Icon.js';
import { MIN_TOUCH_TARGET_PX } from '../theme/useLayout.js';
function variantStyle(variant) {
    switch (variant) {
        case 'primary':
            return { background: 'var(--color-accent)', color: 'var(--color-text-inverse)' };
        case 'danger':
            return { background: 'var(--color-danger)', color: 'var(--color-text-inverse)' };
        case 'secondary':
            return { background: 'var(--color-surface-hover)', color: 'var(--color-text)' };
        case 'ghost':
        default:
            return { background: 'transparent', color: 'var(--color-text)' };
    }
}
export const Button = forwardRef(function Button({ variant = 'primary', style, type = 'button', children, ...rest }, ref) {
    const base = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'var(--space-2)',
        minHeight: '36px',
        padding: '0 var(--space-4)',
        border: 'none',
        borderRadius: 'var(--radius-control)',
        fontFamily: 'var(--font-family-base)',
        fontSize: 'var(--font-md)',
        fontWeight: 'var(--weight-medium)',
        cursor: rest.disabled ? 'default' : 'pointer',
        opacity: rest.disabled ? 0.5 : 1,
        transition: `background var(--motion-fast) var(--ease-standard)`,
        ...variantStyle(variant),
        ...style,
    };
    return (_jsx("button", { ref: ref, type: type, "data-variant": variant, style: base, ...rest, children: children }));
});
export const IconButton = forwardRef(function IconButton({ icon, label, size = 20, touch = false, style, type = 'button', ...rest }, ref) {
    const box = touch ? MIN_TOUCH_TARGET_PX : 36;
    const base = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: `${box}px`,
        height: `${box}px`,
        minWidth: `${box}px`,
        minHeight: `${box}px`,
        padding: 0,
        border: 'none',
        borderRadius: 'var(--radius-control)',
        background: 'transparent',
        color: 'var(--color-text-muted)',
        cursor: rest.disabled ? 'default' : 'pointer',
        opacity: rest.disabled ? 0.5 : 1,
        transition: `background var(--motion-fast) var(--ease-standard)`,
        ...style,
    };
    return (_jsx("button", { ref: ref, type: type, "aria-label": label, title: label, "data-touch": touch ? '' : undefined, style: base, ...rest, children: _jsx(Icon, { name: icon, size: size }) }));
});
//# sourceMappingURL=Button.js.map